var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"title":"Delete"}},[_c('feather-icon',{staticClass:"cursor-pointer",attrs:{"id":"popover-button-1","icon":"TrashIcon"},on:{"click":function($event){return _vm.deleteRow(_vm.data.item.id)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }